<template>
  <div class="lg:w-fit hidden md:flex items-center justify-center">
    <div class="">
      <NuxtLink
        :to="$localePath('/gallery')"
        class="hover:text-primary w-full hover:bg-primary/5 rounded px-2.5 py-1 transition-all duration-300 cursor-pointer"
      >
        <span>{{ $t("nav.links.gallery") }}</span>
      </NuxtLink>
      <NuxtLink
        class="hover:text-primary w-full hover:bg-primary/5 rounded px-2.5 py-1 transition-all duration-300 cursor-pointer"
        :to="$localePath('/contact')"
        >{{ $t("nav.links.contact_us") }}</NuxtLink
      >
    </div>
  </div>
</template>

<script setup lang="ts"></script>
